import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<label>\n  <input type=\"checkbox\" checked={{@checked}} {{on \"click\" (if @checked @remove @add)}}>\n  {{yield}}\n</label>\n", {
  moduleName: "ilios-common/components/dashboard/filter-checkbox.hbs"
});